import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { HashLoader } from "react-spinners";
import CreatePost from "../../components/createPost";
import Header from "../../components/header";
import LeftHome from "../../components/home/left";
import RightHome from "../../components/home/right";
import Stories from "../../components/stories";
import Post from "../../components/post";
import ActiveLiveStreams from "../../components/ActiveLiveStreams";
import LiveStream from "../../components/LiveStream";
import SponsoredAd from "../../components/sponsoredAd";
import { getActiveAds, interleaveFeedAds } from "../../functions/ads";
// import SendVerification from "../../components/home/SendVerification";
import "./style.css";

export default function Home({ setVisible, posts, loading, getAllPosts, onPostDeleted, openWithPicker }) {
  const { user } = useSelector((state) => ({ ...state }));
  const middle = useRef(null);
  const [height, setHeight] = useState();
  const [showLiveStream, setShowLiveStream] = useState(false);
  const [ads, setAds] = useState([]);
  
  useEffect(() => {
    setHeight(middle.current.clientHeight);
  }, [loading, height]);

  useEffect(() => {
    let cancelled = false;
    getActiveAds(user?.token).then((data) => {
      if (!cancelled) setAds(data);
    });
    return () => {
      cancelled = true;
    };
  }, [user?.token]);

  const feedItems = useMemo(() => interleaveFeedAds(posts, ads, 4), [posts, ads]);

  const handleHideAd = (adId) => {
    setAds((prev) => prev.filter((ad) => String(ad._id) !== String(adId)));
  };
  
  const handleLiveStreamClick = () => {
    setShowLiveStream(true);
  };
  return (
    <div className="home" style={{ height: `${height + 150}px` }}>
              <Header 
          page="home" 
          getAllPosts={getAllPosts}
          showMessengerSidebar={false}
          onMessengerToggle={() => {}}
        />
      <LeftHome user={user} />
      <div className="home_middle" ref={middle}>
        <Stories />
        <ActiveLiveStreams />
        {/* {user.verified === false && <SendVerification user={user} />} */}
        <CreatePost 
          user={user} 
          setVisible={setVisible} 
          onLiveStreamClick={handleLiveStreamClick}
          getAllPosts={getAllPosts}
          openWithPicker={openWithPicker}
        />
        {loading ? (
          <div className="sekelton_loader">
            <HashLoader color="#1876f2" />
          </div>
        ) : (
          <div className="posts">
            {feedItems.map((item) =>
              item.kind === "ad" ? (
                <SponsoredAd
                  key={`ad-${item.data._id}`}
                  ad={item.data}
                  user={user}
                  onHide={handleHideAd}
                />
              ) : (
                <Post
                  key={item.data._id}
                  post={item.data}
                  user={user}
                  onPostDeleted={onPostDeleted || (() => getAllPosts(true))}
                />
              )
            )}
          </div>
        )}
      </div>
      <RightHome user={user} />
      
      {showLiveStream && (
        <LiveStream onClose={() => setShowLiveStream(false)} />
      )}
    </div>
  );
}
